import { cn } from "@/lib/utils";
import { Button } from "./ui/button";

interface ButtonProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  btnName?: string | React.ReactNode;
  type?: "submit" | "reset" | "button";
}
const CustomButton = ({
  className,
  disabled,
  btnName,
  type = "button",
  ...props
}: ButtonProps) => {
  return (
    <Button
      className={cn(
        "font-semibold rounded-3xl bg-gradient-to-r from-[#4BD5D6] to-[#009FA6] w-full",
        className
      )}
      type={type}
      {...props}
    >
      {btnName}
    </Button>
  );
};

export default CustomButton;
